import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from "react-router-dom";

import './App.css';
import Signup from './componentes/Signup';
import Login from './componentes/Login';
import DeployTutorialApp from "./componentes/DeployTutorialApp";
import {identifyUser, tryLoggingUser} from "./session";
import ConfirmEmail from "./componentes/ConfirmEmail";

class App extends Component {
  constructor(props) {
    super(props);
    this.tryToLoginAndSetState();
    this.state = {
      loggedIn: null,
      token: null,
      userId: null,
      key: {},
      credentials: {
        email: '',
        password: '',
        'g-recaptcha-response': '',
      },
    };
  }

  tryToLoginAndSetState = () => {
    return tryLoggingUser().then((resp) => {
      if (resp) {
        this.setState({ loggedIn: true });
        this.setState({ userId: resp.userId });
      } else {
        this.setState({ loggedIn: false });
      }
    });
  }

  handleChange = name => value => {
    this.setState(
      {
        ...this.state,
        credentials: {
          ...this.state.credentials,
          [name]: value,
        }
      }
    )
  };

  handleFormChange = name => event => {
    this.handleChange(name)(event.target.value)
  };

  login = (sessionToken, userId, data) => {
    identifyUser(userId, data);
    this.setState({ loggedIn: true });
    this.setState({ token: sessionToken });
    this.setState({ userId });
  };

  setKey = key => {
    this.setState({ key })
  };

  render() {
    const { email } = this.state.credentials;
    return (
      <BrowserRouter>
        <Switch>
          <Route path='/login' render={props => (
            <Login
              {...props}
              credentials={this.state.credentials}
              handleChange={this.handleFormChange}
              login={this.login}
              loggedIn={this.state.loggedIn}
            />)
          }/>
          <Route path='/signup' render={props => (
            <Signup
              {...props}
              credentials={this.state.credentials}
              handleChange={this.handleFormChange}
              setKey={this.setKey}
              loggedIn={this.state.loggedIn}
              handleRecaptchaChange={this.handleChange('g-recaptcha-response')}
            />)
          }/>
          <Route path='/activate-pubsub' render={props => (
            <DeployTutorialApp
              {...props}
              appKey={this.state.key}
              userId={this.state.userId}
            />
          )}/>
          <Route path="/confirm-email" render={props => (
            <ConfirmEmail
              {...props}
              email={email}
              tryToLogin={this.tryToLoginAndSetState}
              loggedIn={this.state.loggedIn}
            />
          )}/>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js